'use strict';

bbw.guest.PhotoAlbumPublicCtrl = bbw.shared.PhotoAlbumBaseCtrl.extend({

    $inject: bbw.shared.PhotoAlbumBaseCtrl.$inject.concat(['$attrs']),

    _getAlbumArguments: function() {
        return {
            user_id: this.$attrs.userId,
            size: 'small',
            full_size: 'default'
        };
    },

    openGallery: angular.noop

});
